// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2V8LV","subMenu":"Menu_subMenu__29TO1","menuItem":"Menu_menuItem__8bx_A","subMenuTitle":"Menu_subMenuTitle__3MeMr","menuPopup":"Menu_menuPopup__1DHiU"};